<template>
	<div id="tu-course-updtime">
		<div class="left">
			<div class="back" @click="toBack"> 
				<i class="fa fa-chevron-left"></i> <span>{{$t("go-back")}}</span>
			</div>
			<template v-if="isStudent">
				<div class="title">
					<span>I need to reschedule the course schedule</span>
				</div>
			</template>
			<template v-else>
				<div class="title" v-if="isUpdateTime">
					{{detail?.user_info?.nickname}} {{$t("has reschedule the lesson")}}
				</div>
				<div class="title" v-else>
					<span>为 {{detail?.user_info?.nickname}} 重新安排课程时间</span>
				</div>
				<div class="reason" v-if="isUpdateTime">
					<div class="reason_title">Reason for modification</div>
					<div class="reason_content">{{detail?.updtime_desc?.tran||detail?.updtime_desc?.reason}}</div>
				</div>
			</template>
			<div class="content" v-if="!isStudent">
				<div class="tip" v-if="qwBookTime">Expected course change to {{qwBookTime}}</div>
				<div class="sub-title">If you agree to reschedule but the student's proposed time doesn't work for you, we suggest contacting the student to find a mutually available time and then return here to update the schedule.</div>
				<div class="group" v-if="false">
					<el-date-picker
				        v-model="value"
				        type="datetime"
				        placeholder="Select date and time"
				        format="YYYY-MM-DD HH:mm"
				        style="width: 100%">
				    </el-date-picker>
				</div>
			</div>
			<div class="content" v-else>
				<div class="sub-title">{{tips}}</div>
				<div class="group">
					<el-input v-model="book_time_show" @click="onTutorDate" placeholder="dd/mm/yyyy hh:mm" readonly></el-input>
				</div>
			</div>
			<div class="content" v-if="isStudent">
				<div class="sub-title">原因</div>
				<div class="group">
					<el-input v-model="reason" :rows="5" type="textarea"></el-input>
				</div>
			</div>
			<!-- <div class="footer">Luke J will be charged 9.37. If you have questions or need any help at all, please feel free to get in touch.</div> -->
			<div class="button">
				<el-link type="primary" @click="toBack">{{$t("go-back")}}</el-link>
				<div v-if="!isStudent">
					<el-button v-if="!qwBookTime" class="tu-button" type="primary" @click="updTimeLesson">
						{{$t("edit-booking")}} <i class="fa fa-arrow-right"></i>
					</el-button>
					<el-button v-if="qwBookTime" class="tu-button" type="warning" @click="updTimeDisLesson">
						{{$t("REFUSE")}}
					</el-button>
					<el-button v-if="qwBookTime" class="tu-button" type="primary" @click="updTimeLesson">
						{{$t("AGREE")}} <i class="fa fa-arrow-right"></i>
					</el-button>
				</div>
				<div v-else>
					<el-button class="tu-button" type="primary" @click="updTimeLessonForStudent">
						{{$t("edit-booking")}} <i class="fa fa-arrow-right"></i>
					</el-button>
				</div>
			</div>
		</div>
		<div class="right">
			<div class="wrap">
				<div class="title">{{$t("detail")}}</div>
				<div class="info">
					<div class="avatar">
				        <el-avatar v-if="detail?.user_info?.avatar_url" :size="60" :src="detail?.user_info?.avatar_url"></el-avatar>
				        <el-avatar v-else :size="60">{{ detail?.user_info?.slot }}</el-avatar>
					</div>
					<div class="detail">
						<div>{{detail?.user_info?.nickname}}</div>
						<div>{{detail?.subject?.subject_name}}({{detail?.subject?.level_name}})</div>
						<div>{{detail?.book?.time}} {{detail?.book?.min_time}} - {{detail?.book?.max_time}}</div>
					</div>
				</div>
				<div class="price">
					<div>{{$t("noun.Price")}}</div>
					<div v-if="detail?.pay_rmb_fee">{{ detail?.pay_rmb_fee }}</div>
					<div v-else>{{ detail?.currency }}{{ detail?.price }}</div>
				</div>
			</div>
		</div>
		<TutorAvailability ref="tutoravailability" @change="handleSelectTime" />
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import CourseApi from '@/api/course'
import TimeControl from '@/utils/time-control'
import moment from 'moment'
import TutorAvailability from '@/components/TutorAvailability'

export default {
	name: "course-cancel",
	components: {
		TutorAvailability
	},
	data() {
		return {
			id: 0,
			detail: {},
			value: "",
			type: "2",
			tips: "",
			book_time: 0,
			reason: ""
		}
	},
	computed: {
		...mapGetters([
			'isStudent'
		]),
		book_time_show() {
			return this.book_time > 0 ? TimeControl.getFormatTime(this.book_time, 'DD/MM/YYYY HH:mm') : '';
		},
		qwBookTime() {
			if(!!this.detail && this.detail.updtime_desc) {
				let desc = this.detail.updtime_desc;
				let status = desc?.status || 0;
				if (desc?.book_time && status == 0) {
					return TimeControl.getFormatTime(desc?.book_time, "Do MMMM") + " " + TimeControl.getFormatTime(desc?.book_time, "HH:mm") + "-" + TimeControl.getFormatTime(desc?.book_time + this.detail.second, "HH:mm")
				}
			}

			return ""
		},
		isUpdateTime() {
			if(!!this.detail && this.detail.updtime_desc) {
				let desc = this.detail.updtime_desc;
				let status = desc?.status || 0;
				if (desc?.book_time && status == 0) {
					return true;
				}
			}

			return false;
		}
	},
	created() {
		this.id = this.$route.params.id;
		if(this.id) {
			this.getApiDetailData();
		}
	},
	methods: {
		getApiDetailData() {
			if(!!!this.id || /^\d+$/.test(this.id) === false) {
				this.$message.error(this.$t('exception.request'))
				this.$router.push({path: '/course'})
				return ;
			}
			CourseApi.info(this.id).then((res) => {
				this.detail = res.data;
				this.detail.book = {
					time: TimeControl.getFormatTime(this.detail.book_time, "Do MMMM"),
					min_time: TimeControl.getFormatTime(this.detail.book_time, "HH:mm"),
					max_time: TimeControl.getFormatTime(this.detail.book_time + this.detail.second, "HH:mm")
				}
				this.book_time = this.detail.book_time;
				if(!!this.detail && this.detail.updtime_desc) {
					let desc = this.detail.updtime_desc;
					let status = desc?.status || 0;
					if (desc?.book_time && status == 0) {
						this.value = new Date(TimeControl.getFormatTime(desc?.book_time, "YYYY-MM-DD HH:mm"));
					}
				}
				this.showTips();
			});
		},
		showTips() {
			if(this.detail && this.detail.book_time) {
				let now_time = (new Date).getTime()/1000;
				if(this.detail.book_time <= (now_time + 86400)) {
					this.tips = "本次更改时间距离上课开始不足24小时，是否修改成功将由老师决定。如果修改成功，代表老师同意免费取消一次课程，所以强烈建议您向老师说明修改的原因。";
				} else {
					this.tips = "本次更改时间距离上课开始超过24小时。提交以后，课程状态会自动变成待确认。建议您同时联系老师，尽快确认新的上课时间。";
				}
			}
		},
		toBack() {
			this.$router.push({ path: `/course/${this.id}` });
		},

		// CourseApi.cancel
		// CourseApi.cancelling
		updTimeLesson() {
			if (this.value == "") {
				this.$message.error(this.$t('required.date'));
				return
			}
			let book_time = TimeControl.getUnixTime(this.value);
			let now_time = TimeControl.getUnixTime(new Date);
			if(book_time <= now_time) {
				this.$message.error(this.$t('required.gt-date'));
				return ;
			}
			CourseApi.updateTime({course_id: this.id, start_date: book_time, cur_timezone: moment.tz.guess(true), reason: this.reason}).then(res => {
				this.$message.success(this.$t('required.date-update-ok'));
				setTimeout(() => {
					this.toBack();
				}, 2000);
			});
		},
		updTimeLessonForStudent() {
			this.value = this.book_time;
			this.updTimeLesson();
		},
		updTimeDisLesson() {
			let book_time = TimeControl.getUnixTime(this.value);
			// 不同意
			CourseApi.updateTime({course_id: this.id, start_date: book_time, operate: "2"}).then(res => {
				this.$message.success(this.$t('required.date-update-ok'));
				setTimeout(() => {
					this.toBack();
				}, 2000);
			});
		},
		onTutorDate() {
			this.$refs.tutoravailability.open(this.detail.tutor_id);
		},
		handleSelectTime(value) {
			this.book_time = value > 0 ? value : 0;
		}
	}
}
</script>
<style lang="less">
#tu-course-updtime {
	display: flex;
	justify-content: space-between;
	padding: 0 100px;

	.left {
		width: 70%;

		.back {
			font-size: 20px;
			cursor: pointer;
		}

		.title {
			margin: 20px 0;
			font-weight: 500;
			font-size: 28px;
			line-height: 1.2;
		}

		.reason {
			.reason_title {
				font-size: 18px;
				font-weight: 500;
			}

			.reason_content {
				font-size: 14px;
				line-height: 20px;
				margin-top: 10px;
				border: 1px solid #CCCCCC;
				border-radius: 4px;
				padding: 10px;


			}

			.group {
				margin-top: 10px;

				.el-radio__label {
					font-weight: 600;
				}

				.el-radio {
					height: 30px;

					.el-radio__inner {
						width: 18px;
						height: 18px;
					}

					.el-radio__inner::after {
						width: 6px;
						height: 6px;
					}
				}
			}
		}

		.content {
			margin-top: 20px;

			.tip {
				color: #909399;
				line-height: 20px;
			}
			.sub-title {
				margin-top: 20px;
				font-weight: 600;
				font-size: 18px;
				line-height: 24px;
			}
			.group {
				margin-top: 10px;

				.el-radio__label {
					font-weight: 600;
				}

				.el-radio {
					height: 30px;

					.el-radio__inner {
						width: 18px;
						height: 18px;
					}

					.el-radio__inner::after {
						width: 6px;
						height: 6px;
					}
				}
			}
		}

		.footer {
			font-size: 14px;
			margin-top: 15px;
		}

		.button {
			margin-top: 20px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.tu-button {
				font-weight: 600;
			}
		}
	}

	.right {
		padding-top: 40px;
		.wrap {
			width: 100%;
			border: 1px solid #CCCCCC;
			padding: 10px;
			border-radius: 4px;

			.title {
				font-size: 18px;
				font-weight: 600;
				padding: 10px 0;
				border-bottom: 1px solid #CCCCCC;
			}
			.info {
				padding: 15px 0;
				display: flex;
				gap: 10px;
				align-items:center;
				justify-content: flex-start;
				border-bottom: 1px solid #CCCCCC;

				.avatar {
					.image {
				       	width: 120px;
				       	height: 120px;
				       	flex-shrink: 0;
					}
				}

				.detail {
					font-size: 12px;
					line-height: 14px;
					div:first-child {
						font-weight: 600;
						font-size: 14px;
						margin-bottom: 5px;
					}
				}
			}
			.price {
				margin-top: 10px;
				display: flex;
				align-items: center;
				justify-content: space-between;
				font-size: 14px;
			}
		}
	}
}
</style>